module.exports = "https://trybtryb-legacy.web.app/img/tryb_light.d7560aa0.webp";